import { render } from "./wechat.vue?vue&type=template&id=7fac0278&scoped=true"
import script from "./wechat.vue?vue&type=script&lang=js"
export * from "./wechat.vue?vue&type=script&lang=js"

import "./wechat.vue?vue&type=style&index=0&id=7fac0278&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fac0278"]])

export default __exports__